import { useContext } from 'react';

import { SubtitleSettingsSettersContext, SubtitleSettingsContext } from '../../contexts/subtitles';

export const useSubtitlesSettings = () => useContext(SubtitleSettingsContext);

export const useSubtitlesSettingsSetters = () => useContext(SubtitleSettingsSettersContext);
